export default "__VITE_ASSET__CTPNTf6f__"